import { Validators } from '@angular/forms';

export class AbnAcnModel {
  abnAcnType = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  abnAcnNumber = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  abnAcnAvailable = {
    value: false,
    validation: Validators.compose([
    ])
  };
  abnAcnConfirmation = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  abnAcnDirector = {
    value: false,
    validation: Validators.compose([
      Validators.required
    ])
  };
}
